import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  FetchFixedTemplatesFailure,
  FetchFixedTemplatesRequest,
  FetchFixedTemplatesSuccess,
  UpdateFixedTemplatesFailure,
  UpdateFixedTemplatesRequest,
  UpdateFixedTemplatesSuccess,
} from './fixed-templates.actions'
import { FixedTemplatesService } from './fixed-templates.service'
import * as FixedTemplatesTypes from './fixed-templates.types'

@Injectable()
export class FixedTemplatesEffects {
  constructor(
    private actions: Actions,
    private fixedTemplatesService: FixedTemplatesService,
    private router: Router,
  ) {}

  FetchFixedTemplates$ = createEffect(() =>
    this.actions.pipe(
      ofType(FixedTemplatesTypes.FETCH_FIXED_TEMPLATES_REQUEST),
      switchMap((action: FetchFixedTemplatesRequest) => {
        return this.fixedTemplatesService.fetchFixedTemplates().pipe(
          map((result) => {
            return new FetchFixedTemplatesSuccess(result.data.fixedTemplates)
          }),
          catchError((err, caught) => {
            return of(new FetchFixedTemplatesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateFixedTemplates$ = createEffect(() =>
    this.actions.pipe(
      ofType(FixedTemplatesTypes.UPDATE_FIXED_TEMPLATES_REQUEST),
      switchMap((action: UpdateFixedTemplatesRequest) => {
        return this.fixedTemplatesService
          .updateFixedTemplates(action.payload)
          .pipe(
            switchMap((result) => {
              return [
                new UpdateFixedTemplatesSuccess(),
                new FetchFixedTemplatesRequest(),
              ]
            }),
            catchError((err, caught) => {
              return of(new UpdateFixedTemplatesFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
